import { Component, Input, OnInit } from '@angular/core';

export class EaNew {
  index: number;
  title: string;
  category: string;
  image: string;
  link: string;
  description: string;
  lead: string;

  constructor(
    index: number,
    title: string,
    category: string,
    description: string,
    lead: string,
    image: string,
    link: string,
  ) {
    this.index = index;
    this.title = title;
    this.category = category;
    this.description = description;
    this.lead = lead;
    this.image = image;
    this.link = link;
  }
}

@Component({
    selector: 'ea-new',
    templateUrl: './ea-new.component.html',
    styleUrls: ['./ea-new.component.scss'],
    standalone: false
})
export class EaNewComponent implements OnInit {
  @Input() index: number;
  @Input() title: string;
  @Input() category: string;
  @Input() description: string;
  @Input() lead: string;
  @Input() image: string;
  @Input() link: string;
  @Input() loading: boolean = false;

  @Input() set eaNew(eaNew: EaNew) {
    this.index = eaNew.index;
    this.title = eaNew.title;
    this.category = eaNew.category;
    this.description = eaNew.description;
    this.lead = eaNew.lead;
    this.image = eaNew.image;
    this.link = eaNew.link;
  }

  constructor() {}

  ngOnInit() {}
}
